@tailwind base;
@tailwind components;
@tailwind utilities;

/* The inlined Cox Automotive SVG has only a viewBox (no intrinsic width/height),
   so size it from the anchor's h-4 container and preserve aspect ratio. */
svg {
  height: 100%;
  width: auto;
  display: block;
}
